import { useState, useEffect } from 'react';
import { interactiveServiceFetch } from '../../services/interactiveServiceFetch';
import { INTERACTIVE_SERVICE_BASE_URL } from '../constants';

const ARTIFACT_API_PREFIX = `${INTERACTIVE_SERVICE_BASE_URL}/v2`;

/**
 * Hook for lazily fetching artifact content from the backend.
 *
 * During live streaming, artifacts arrive with inline `data` — this hook
 * is a no-op when `contentUrl` is falsy.  On session reload, the backend
 * returns a `content_url` (relative backend path) instead of `data`;
 * this hook fetches the content via the authenticated backend proxy.
 */
const useArtifactContent = contentUrl => {
    const [content, setContent] = useState(null);
    const [isLoading, setIsLoading] = useState(!!contentUrl);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!contentUrl) return;

        let cancelled = false;
        setIsLoading(true);
        setError(null);

        interactiveServiceFetch(`${ARTIFACT_API_PREFIX}/${contentUrl}`)
            .then(res => {
                if (!res.ok) throw new Error(`Failed to fetch artifact: ${res.status}`);
                return res.text();
            })
            .then(text => {
                if (!cancelled) {
                    setContent(text);
                    setIsLoading(false);
                }
            })
            .catch(err => {
                if (!cancelled) {
                    setError(err.message);
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [contentUrl]);

    return { content, isLoading, error };
};

export default useArtifactContent;
